// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `::ng-deep .p-progressbar {
  height: 0.5rem !important;
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/app/core/progress-bar/progress-bar.component.scss"],"names":[],"mappings":"AAAA;EACI,yBAAA;EACA,WAAA;AACJ","sourcesContent":["::ng-deep .p-progressbar{\n    height: 0.5rem !important;\n    width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
